import { AnswerUpdateHistory } from "../../../types/nftType";
import styles from "./editLog.module.scss";

type Props = {
  answerUpdateHistories: Array<AnswerUpdateHistory> | null | undefined;
};

const EditLog = ({ answerUpdateHistories }: Props) => {
  if (!answerUpdateHistories) return <></>;

  const sortedHistories = [...answerUpdateHistories];
  // 作成日でソート
  sortedHistories?.sort((a, b) => {
    if (a.createdAt > b.createdAt) {
      return 1;
    }
    if (a.createdAt < b.createdAt) {
      return -1;
    }
    return 0;
  });

  return (
    <div>
      <div className="mt-4 mb-4 px-2 border border-white"></div>
      <p className="text-xl">EDIT LOG:</p>
      <div className={styles.historiesWrapper}>
        {sortedHistories.map((history, index) => (
          <div className={styles.history} key={index}>
            <div className={styles.date}>
              {new Date(history.createdAt)?.toLocaleDateString()}
            </div>
            <div className={styles.answerAndCredit}>
              <div className={styles.answer}>ANSWER:{history.answer}</div>
              <div className={styles.credit}>CREDIT:{history.ownerCredit}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditLog;
